import { dobToDate } from '@ux/mappers/date.mapper';
import { DAYS_IN_YEAR, MONTHS_IN_YEAR, MS_IN_ONE_DAY } from '@booking/constants/forms.constants';

export function travelerAgeInYears(birth: string, reservationDate: Date): number {
  return Math.floor(diffTime(birth, reservationDate) / (MS_IN_ONE_DAY * DAYS_IN_YEAR));
}

export function travelerAgeInMonths(birth: string, reservationDate: Date): number {
  return Math.floor((diffTime(birth, reservationDate) / MS_IN_ONE_DAY / DAYS_IN_YEAR) * MONTHS_IN_YEAR);
}

function diffTime(birth: string, reservationDate: Date): number {
  const birthDate = dobToDate(birth);
  reservationDate.setHours(0, 0, 0, 0);
  birthDate?.setHours(0, 0, 0, 0);
  return reservationDate.getTime() - birthDate?.getTime();
}
